import type { PostHogConfig } from 'posthog-js';

/**
 * Analytics on a hosted meeting's join page, `/m/<code>` (P7.15 R10).
 *
 * The join page is a door for guests: people outside Ricoh with no account,
 * who never see the employee app's analytics terms. The app has no consent
 * choice for them, so a page load that starts on `#/m/…` starts PostHog
 * opted OUT, with no session replay and nothing stored in the browser
 * (`persistence: 'memory'`: no PostHog cookie or `localStorage` key).
 *
 * A signed-in employee on the same page is opted back in by the app's
 * existing consent rule, `ViewerService` applying the viewer's
 * `productAnalytics` setting, so their events still flow. Replay stays off
 * for that page load. A guest is never opted in until a consent choice
 * exists for them (a decision for Nath and the DPO).
 *
 * With the shared cookie consent banner on (CONSENT_ENABLED), that choice is
 * the banner's: these options still apply, PostHog starts only once there is
 * a choice, it opts in only on an acceptance (a guest's included), and the
 * page is never recorded (`recordingAllowed: false`). ViewerService no
 * longer opts anyone in.
 */
export const JOIN_SURFACE_POSTHOG_OPTIONS = {
  opt_out_capturing_by_default: true,
  disable_session_recording: true,
  persistence: 'memory',
} as const satisfies Partial<PostHogConfig>;

/** True when this page load started on a hosted meeting's join route. */
export function isMeetingJoinSurface(hash: string): boolean {
  return hash.startsWith('#/m/');
}
